import { http } from './http'
import Cookies from 'universal-cookie'
import config from 'config'

const cookies = new Cookies()

const hasJwt = () => {
  const jwtToken = cookies.get(config.require('JWT_COOKIE_NAME'))
  return jwtToken && jwtToken.length > 0
}

const cookieDomain = () => config.get('MOCKS_ENABLED') ? null : config.require('COOKIE_DOMAIN')

export const getUser = () => {
  return http().get('/api/end_users')
}

export const createUser = (fragment_id, box_token, end_user, additionalData = {}) => {
  return http().post('/api/end_users', { fragment_id, box_token, end_user, ...additionalData })
}

export const mseCreateUser = (fragment_id, box_token, end_user, additionalData = {}) => {
  return http().post('/api/end_users/mse_create', { fragment_id, box_token, end_user, ...additionalData })
}

export const loginFromMse = (end_user, additionalData) => {
  return http().post('/api/end_users/mse_login', { end_user, ...additionalData })
}

export const loginUserFromRememberToken = token => {
  return http().post('/api/sessions/authenticate_with_token', { token })
}

export const updateUser = end_user => {
  return http().put('/api/end_users', { end_user })
}

export const updatePassword = end_user => {
  return http().put('/api/end_users/update_password', { end_user })
}

export const requestNewUserPassword = (email, url) => {
  return http().post('/api/end_users/password_request', { email, url })
}

export const verifyUserPasswordRequestCode = (email, code) => {
  return http().post('/api/end_users/password_request/verify_code', { email, code })
}

export const updatePasswordRequest = (end_user, token) => {
  return http().put('/api/end_users/password_request/update_password', { end_user, token })
}

export const updatePasswordRequestWithCode = (end_user, email, code) => {
  return http().put('/api/end_users/password_request/update_with_code', { end_user, email, code })
}

export const updatePhoneNumber = end_user => {
  return http().put('/api/end_users/phone_number_request', { end_user })
}

export const confirmPhoneNumberCode = code => {
  return http().put('/api/end_users/phone_number_request/confirm', { code })
}

export const resendPhoneNumberChangeCode = () => {
  return http().put('/api/end_users/phone_number_request/resend_code', {})
}

export const confirmPhoneNumber = (fragment_id, box_token, phone_number_confirmation_code) => {
  return http().put('/api/end_users/validate_phone_number', {
    fragment_id,
    box_token,
    phone_number_confirmation_code,
  })
}

export const resendPhoneNumberConfirmation = () => {
  return http().put('/api/end_users/resend_phone_number_confirmation')
}

export const SMS_RESEND_STATUSES = {
  UNRESOLVED: null,
  SUCCESS: 'success',
  ERROR: 'error',
  LIMIT_REACHED: 'limit-reached',
}

export const getPhoneNumberConfirmationToken = () => cookies.get(config.require('PHONE_CONFIRMATION_COOKIE_NAME'))

export const loginUser = (values, boxToken = null, fragment_id = null, force = false) => {
  if (boxToken) values.box_token = boxToken
  if (fragment_id) values.fragment_id = fragment_id
  if (force) values.force = force
  return http().post('/api/sessions', values)
}

export const reloginUser = () => {
  if (hasJwt()) {
    return getUser()
  }
  else {
    return new Promise((resolve, reject) => {
      const rememberToken = cookies.get(config.require('REMEMBER_COOKIE_NAME'))

      if (rememberToken && rememberToken.length > 0) {
        loginUserFromRememberToken(rememberToken).then(response => {
          resolve(response)
        })
        .catch(e =>
          reject(e)
        )
      }
      else reject()
    })
  }
}

export const logoutUser = () => {
  const removeOptions = {
    domain: cookieDomain()
  }

  return new Promise((resolve, reject) => {
    cookies.remove(config.require('JWT_COOKIE_NAME'), removeOptions)
    cookies.remove(config.require('REMEMBER_COOKIE_NAME'), removeOptions)
    resolve()
  })
}

export const PASSWORD_REQUEST_EMAIL_COOKIE_NAME = 'Portal-PasswordRequest-email'
export const VERIFICATION_CODE_COOKIE_NAME = 'Portal-PasswordRequest-verificationCode'
export const PASSWORD_REQUEST_COOKIE_OPTIONS = {
  expires: null,
  path: '/'
}
